import {http} from './config'

export default class Service{

  constructor(nomeControle){
    this._nomeControle = nomeControle;
  }

  GetHeader(include){
    let header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "include": ""
      }
    }

    if(include){
      header.headers.include = include;
    }

    return header;
  }

  GetParamentroPaginacaoOrdenacao(page, pageSize, sortBy, desc, search, columns, filter){
    let strParameters = '?';

    if (pageSize){
      if (pageSize > -1) {
        strParameters += '$Top=' + pageSize;

        if (page){
          strParameters += '&$Skip=' + (page - 1) * pageSize;
        }
      }
    }

    if (sortBy){

      if (sortBy.length > 0){
      
        strParameters += strParameters ? '&' : '?';
        strParameters += '$OrderBy=';

        sortBy.forEach(function (item, index){

          strParameters += item.replace('.', '/');

          if (desc.length > 0) {
            if (desc[index] === true) {
              strParameters += ' desc';
            }
          }

          if (index < sortBy.length - 1) {
            strParameters += ', ';
          }

        });
  
      }
    }

    if (search){

      strParameters += strParameters ? '&' : '?';

      let newColumns = [];

      columns.forEach(column => {
      
        if (column.value && column.value != 'actions') {
          
          if (column.type) {
            if (column.type === 'number' && !isNaN(search)){
              newColumns.push(`${column.value} eq ${search}`);
            }
            else if(column.type === 'date' && search.length === 10){
              if(search.indexOf('/') == 2 && search.indexOf('/',3) == 5){
                const [day,month,year] = search.split("/");
                if(!isNaN(day) && !isNaN(month) && !isNaN(year)){
                  const data = new Date(year, month-1, day).yyyymmdd();
                  newColumns.push(`${column.value} eq ${data}`);
                }
              }
            }
            else if(column.type === 'boolean' && typeof search ==='boolean'){
              newColumns.push(`Contains(${column.value}, '${search}')`);
            }
          } 
          else {
            let newColumn = column.value.replace('.', '/');
            newColumns.push(`Contains(toupper(${newColumn}), toupper('${search}'))`);
          }

        }
  
      });

      strParameters += '$filter=' + newColumns.join(' or ');

    }

    if(filter){
      strParameters += search ? ' and ' + filter : '&$filter=' + filter;
    }

    return strParameters;
  }

  Listar(page, pageSize, sortBy, desc, search, columns, filter, include){
    return http.get(`${this._nomeControle}${this.GetParamentroPaginacaoOrdenacao(page, pageSize, sortBy, desc, search, columns, filter)}`, this.GetHeader(include));
  }

  ListarTudo(include, sortBy){
    let strParameters = this._nomeControle;

    if(sortBy){
      strParameters += `?$orderby=${sortBy}`;
    }
    
    return http.get(strParameters, this.GetHeader(include));
  }

  ObterPorId(id, include){
    return http.get(`${this._nomeControle}/${id}`, this.GetHeader(include))
  }

  Excluir(id){
    return http.delete(`${this._nomeControle}/${id}`, this.GetHeader());
  }
 
  async Salvar(modelo){
    return await modelo.id > 0 ? http.put(`${this._nomeControle}/${modelo.id}`, modelo, this.GetHeader()) : http.post(this._nomeControle, modelo, this.GetHeader());
  }

  SalvarPatch(modelo, id){
    return http.patch(`${this._nomeControle}/${id}`, modelo, this.GetHeader());
  }

  getNomeControle(){
    return this._nomeControle;
  }

}